// Prefix for the project, used in various places such as cdk resource names
export const projectPrefix: Readonly<string> = 'pdm-ea';

// Used to indicate that a participant is not required for a workflow
export const participantNotRequired: Readonly<string> = '00000000-0000-0000-0000-000000000000';

export const PRICE_FIELDS = {
    LIST_PRICE_NEW_PART: 'field-list-price-new-part',
    LIST_PRICE_SPARE_PART: 'field-list-price-spare-part',
    LIST_PRICE_REPAIR_PART: 'field-list-price-repair-part',
    LIST_PRICE_RETURN: 'field-list-price-return',
    E_PRICE_NEW_PART: 'field-e-price-new-part',
    E_PRICE_SPARE_PART: 'field-e-price-spare-part',
    E_PRICE_REPAIR_PART: 'field-e-price-repair-part',
    E_PRICE_RETURN: 'field-e-price-return',
    STOCK_PURCHASE_PRICE_NEW_PART: 'field-stock-purchase-price-new-part',
    STOCK_PURCHASE_PRICE_SPARE_PART: 'field-stock-purchase-price-spare-part',
    STOCK_PURCHASE_PRICE_REPAIR_PART: 'field-stock-purchase-price-repair-part',
    STOCK_PURCHASE_PRICE_RETURN: 'field-stock-purchase-price-return'
} as const;

export const PRICE_FIELD_NAMES: readonly string[] = Object.freeze(Object.values(PRICE_FIELDS));
export const ON_REQUEST_PRICE_VALUE: Readonly<string> = 'oR';
